import React from 'react';

const Footer = () => {

    return (
        <footer className="bg-white footerContainer">
            <div className="container-fluid text-center">
                <div className="row mb-md-n5" style={{ minHeight: "250px" }}>
                    <div className="dropdown dropright align-self-md-start col-md-5">
                        <button type="button" className="btn btnNewsletter shadow-none mx-auto bg-transparent border-transparent d-flex text-dark align-items-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fas fa-envelope" style={{ fontSize: "35px", marginRight: "2px" }} aria-hidden="true"></i> Suscribirse al Newsletter
                        </button>
                        <div className="dropdown-menu p-3">
                            <form action="#" method="post" id="subscribe">
                                <div className="form-row align-items-center">
                                    <div className="col-auto">
                                        <label className="sr-only" htmlFor="ds_email_suscribe">Correo Electrónico</label>
                                        <input type="email" className="form-control email required" aria-label="Correo Electrónico" relvalidate="sucr" placeholder="Correo Electrónico" id="ds_email_suscribe" name="ds_email_suscribe" />
                                        <label id="ds_email_suscribe-error" className="error" htmlFor="ds_email_suscribe" style={{ fontSize: "12px" }}>* Campo requerido.</label>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-outline-danger btnSuscribe" validate="sucr" id="btnsuscribe" ajaxaction="sendsuscribe" style={{ cursor: "pointer" }}>Suscribirse</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <p className="mt-2"><a href="mailto:info@cic.travel">info@cic.travel</a></p> */}
                    </div>
                    <div className="col-md-2 align-self-md-center mb-5 mb-md-0">
                        <a href="https://www.gogetssl.com" rel="nofollow" title="GoGetSSL Site Seal Logo" target="_blank">
                            <img src="https://gogetssl-cdn.s3.eu-central-1.amazonaws.com/site-seals/gogetssl-static-seal.svg" width="130" title="GoGetSSL Site Seal, Protected website" alt="GoGetSSL Site Seal" />
                        </a>
                    </div>
                    {/* <div className="col-md-2 align-self-md-center">
                        <img src="https://www.ciccolombia.travel//images/Parameters/certificadoCalidad.png" className="logo-footer mb-3" width="" />
                    </div>
                    <div className="col-md-2 align-self-md-center">
                        <img src="https://filescictravel.blob.core.windows.net/naideth-colombia/ANATO.png" className="img-fluid LogosFooterDiagonal" />
                    </div>
                    <div className="col-md-2 align-self-md-center">
                        <img src="https://filescictravel.blob.core.windows.net/naideth-colombia/IATA.jpg" className="img-fluid LogosFooterDiagonal pb-4" />
                    </div> */}
                </div>
                <p className="text-center pb-3">© Todos los derechos reservados 2020</p>
            </div>
        </footer>
    )
}

export default Footer;
